var map = {
	"./review1.png": 2029,
	"./review2.png": 8262,
	"./review3.png": 3359,
	"./review4.png": 7488,
	"./review5.png": 3241,
	"./review6.png": 9234,
	"./review7.png": 2891,
	"./review8.png": 2588
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2963;